import api from "./apiConfig";

export const UPLOAD_FILE = async (id, filename, mimetype, address) => {
	try {
		const response = await api.post(`/upload-url/${id}`, {
			filename,
			mimetype,
			address,
		});
		return response.data;
	} catch (error) {
		console.error("Error al obtener la URL firmada:", error);
		throw error;
	}
};

export const GET_FILE = async (id, data) => {
	try {
		const response = await api.post(`/download-url/${id}`, data);
		return response.data.data;
	} catch (error) {
		console.error("Error al obtener la url:", error);
		throw error;
	}
};

export const DELETE_FILE = async (data) => {
	try {
		await api.post("/delete-file", data);
	} catch (error) {
		console.error("Error al eliminar el documento:", error);
		throw error;
	}
};
